
import React, { useState } from "react";
import axios from "axios";
import './Weather.css';
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";


export default function Weather(props) {
    const [ready, setReady] = useState(false);
    const [weatherData, setWeatherData] = useState({});
    const [city,setCity] = useState(props.defaultCity);
    const [unit, setUnit] = useState("celsius");
   
    function handleResponse(response) {
        setWeatherData(response.data);
        setReady(true);
    }

    function search() {
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=60ad999468395538cd607575dc0c5650&units=metric`;
    axios.get(apiUrl).then(handleResponse);
}

function handleSubmit(event) {
event.preventDefault();
search();
}

function handleCityChange(event){
setCity(event.target.value);
}

    if (ready) {
return (
     <div className="Weather">
         <form onSubmit={handleSubmit}>
             <div className="row mt-3">
                 <div className="col-9">
             <input 
             type="search" 
             placeholder="How is the weather in..." 
             className="form-control"
             autoFocus="on"
             onChange={handleCityChange}
             />
             
             </div>
             <div className="col-3">
             <input 
             type="submit"
             value="Search"
             className="btn btn-primary w-100" />
             </div>
             </div>
</form>
<WeatherInfo info={weatherData} unit={unit} setUnit={setUnit} />
<br />
<WeatherForecast coordinates={weatherData.coord} unit={unit} />

         </div>
);
 }
 else {
    search();
    return "Loading...";
 }
}